import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IOEMOrderFulfillmentTime } from '../bp-profiles-oem-data.service';

@Component({
  selector: 'oft-detail',
  template: `
    <activity-indicator *ngIf="loading"></activity-indicator>
    
    <ng-container *ngIf="!loading && oftDetail">
      <label class="col-form-label" translate [translateParams]="{ days: oftDetail.oft }">BPPROFILES.OEM.BUSINESS_DAYS</label>
      <table class="oft-table table table-bordered table-striped">
        <thead>
          <tr>
            <th>Step</th>
            <th>SLA</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let slaValue of oftDetail.fulfillmentSlaValues">
            <td>{{slaValue.description}}</td>
            <td>{{slaValue.days}}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  `
})
export class OFTDetailComponent implements OnChanges {
  @Input() public oftDetail:IOEMOrderFulfillmentTime;
  @Input() public loading:boolean;

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.oftDetail) {
      this.oftDetail = changes.oftDetail.currentValue;
    }
    if (changes.loading) {
      this.loading = changes.loading.currentValue;
    }
  }
}